import { Paper, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { toPx } from "../MuiHelpers";
import { BodyTextM, HeadingXL } from "../Typography";

const SUSTAINABILITY_PAGE_MAX_WIDTH_PX = 750;

export const Wrapper = styled(Stack)(() => ({
    display: "flex",
    maxWidth: toPx(SUSTAINABILITY_PAGE_MAX_WIDTH_PX),
    margin: "48px auto",
    textAlign: "center",
    flexDirection: "column",
}));

export const Title = styled(HeadingXL)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(7),
}));

export const ContributionInfoText = styled("div")(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(3),
    display: "flex",
}));

export const Paragraph = styled(BodyTextM)(({ theme }) => ({
    marginBottom: theme.spacing(5),
}));

export const RadioGroupWrapper = styled(Paper)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch",
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    marginTop: theme.spacing(1),
    "&>.MuiStack-root": {
        width: "100%",
        textAlign: "start",
    },
}));
